import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { CoreService } from 'src/app/core/services/core.service';
import { ApiHrService } from 'src/app/core/services/api-hr.service';
import { AuthAdminService } from 'src/app/feature/auth/services/auth-admin.service';

@Component({
  selector: 'app-topbar-sidebar',
  templateUrl: './topbar-sidebar.component.html',
  styleUrls: ['./topbar-sidebar.component.scss']
})
export class TopbarSidebarComponent implements OnInit {
  @ViewChild('dropdown', { static: false }) dropdown: NgbDropdown;
  @Input() is_close_sidebar_menu: boolean = false;
  @Output() is_close_sidebar_menuChange = new EventEmitter<boolean>();


  filterSearch = {
    name: '',
    limit: 5,
  };
  listSugestedSearch = [];
  isLoadingSearch = true;
  isClickSearch = false;
  isShowSearchMini = false;

  userLogin;
  listNotifikasi: any = [];
  unmarked_notifications = 0;
  list_unmark_notifications_id = [];
  max_length_message: number = 70;

  variableNavSidebar; // Inisialisasi agar tidak undefined

  constructor(
    public authAdminService: AuthAdminService,
    private router: Router,
    private coreService: CoreService,
    private apiHrService: ApiHrService

  ) { }

  ngOnInit(): void {
    this.authAdminService.getProfile().subscribe((user: any) => {
      this.userLogin = user;
    });
    this.getNotifikasi();

    this.coreService.variableNavSidebar$.subscribe(val => {
      this.variableNavSidebar = val[val.length - 1];
    });





  }


  /// NOTIFIKASI///
  getNotifikasi() {
    // this.authAdminService.getNotification({}).subscribe((res: any) => {
    //   this.listNotifikasi = res.data.list;
    //   this.unmarked_notifications = res.data.unmarked_notifications;
    //   this.list_unmark_notifications_id = res.data.list_unmark_notifications_id;
    // })
  }
  readAllNotif() {
    this.authAdminService.readAllNotif({ list_notification_id: this.list_unmark_notifications_id }).subscribe((res: any) => {
      if (res.data) {
        this.getNotifikasi();
      }
    });
  }
  showActionNotif(id) {
    const cardDiv = document.getElementById("card-notif-" + id);
    if (cardDiv) {
      cardDiv.classList.add('notification-hover');
    }
  }
  hideActionNotif(id) {
    const cardDiv = document.getElementById("card-notif-" + id);
    if (cardDiv) {
      cardDiv.classList.remove('notification-hover');
    }
  }
  setExpandMessage(val) {
    if (val.url != null) {
      this.dropdown.close();
      this.openNotif(val);
    } else {
      if (typeof (val.is_full) == 'undefined' || val.is_full == false) {
        val.is_full = true;
      } else {
        val.is_full = false;
      }
      if (!val.marked) {
        this.readNotif(val);
      }
    }
  }

  readNotif(val) {
    if (val.seen_by != null || val.seen_by != this.userLogin.id) {
      this.authAdminService.readNotif({ id: val.id }).subscribe((res: any) => {
        if (res.data) {
          this.getNotifikasi();
        }
      });
    }
  }

  openNotif(val) {
    if (val.marked == false) {
      this.authAdminService.readNotif({ id: val.id }).subscribe((res: any) => {
        this.getNotifikasi();
        if (res.data) {
          this.goToPage(val);
        }
      });
    } else {
      this.goToPage(val);
    }
  }

  goToPage(val) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(val.url);
    });
  }
  /// NOTIFIKASI///


  btnCloseSidebar() {
    this.is_close_sidebar_menu = !this.is_close_sidebar_menu;
    this.is_close_sidebar_menuChange.emit(this.is_close_sidebar_menu);
  }

  logout() {
    this.authAdminService.requestLogout().subscribe((res: any) => {
      this.authAdminService.logout();
      this.router.navigate(['auth/login']);

    }, (err: any) => {
      this.apiHrService.alertError('Mohon Maaf', err.error.errors);
    });
  }

}
